import React, { useState, useCallback } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import InputArea from './InputArea';
import ConnectionState from './ConnectionState';
import useVisualViewport from '../hooks/useVisualViewport';

const ChatLayoutMobile = ({ colors, header, authStatus, isReady, onRetry, messageListProps, inputProps }) => {
    useVisualViewport();
    const [scrollToBottomSignal, setScrollToBottomSignal] = useState(0);
    const handleInputFocus = useCallback(() => setScrollToBottomSignal(n => n + 1), []);

    return (
        <Flex
            position="fixed"
            top="0"
            left="0"
            right="0"
            justifyContent="center"
            overflow="hidden"
            style={{
                height: 'var(--chat-vh, 100dvh)',
                transform: 'translateY(var(--chat-vv-offset, 0px))',
                background: colors.chatBg,
            }}
        >
            <Box
                w="100%"
                h="100%"
                display="flex"
                flexDirection="column"
                overflow="hidden"
                position="relative"
                style={{ background: colors.chatBg, color: colors.textPrimary }}
            >
                <ChatHeader colors={colors} {...header} />

                {authStatus === 'error' && (
                    <ConnectionState variant="error" colors={colors} onRetry={onRetry} />
                )}

                {authStatus !== 'error' && !isReady && (
                    <ConnectionState variant="connecting" colors={colors} />
                )}

                {authStatus === 'authorized' && (
                    <>
                        {isReady && (
                            <Box flex={1} minH={0} overflow="hidden" display="flex" flexDirection="column">
                                <MessageList colors={colors} {...messageListProps} scrollToBottomSignal={scrollToBottomSignal} />
                            </Box>
                        )}
                        <Box
                            px={2}
                            flexShrink={0}
                            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
                        >
                            <InputArea colors={colors} {...inputProps} disabled={!isReady} onFocus={handleInputFocus} />
                        </Box>
                    </>
                )}
            </Box>
        </Flex>
    );
};

export default ChatLayoutMobile;
